export enum GlobalEventsFilters {
  departmentId = 'departmentId',
  globalEventTypeId = 'globalEventTypeId',
}
